export const footerCols = {
  platform: [
    {
      _id: 1,
      title: "Bepul Kurslar",
      href: "#",
    },
    {
      _id: 2,
      title: "Pullik Kurslar",
      href: "#",
    },
    {
      _id: 3,
      title: "Practicum [beta]",
      href: "#",
    },
  ],

  company: [
    {
      _id: 1,
      title: "Biz haqimizda",
      href: "#",
    },
    {
      _id: 2,
      title: "Ommaviy oferta",
      href: "#",
    },
  ],

  practicum: [
    {
      _id: 1,
      title: "Ilk Qadam: C va Python",
      href: "#",
    },
    {
      _id: 2,
      title: "Data Science va Sun'iy Intellekt",
      href: "#",
    },
    {
      _id: 3,
      title: "Full Stack Python",
      href: "#",
    },
    {
      _id: 4,
      title: "MERN",
      href: "#",
    },
    {
      _id: 5,
      title: "GO",
      href: "#",
    },
    {
      _id: 6,
      title: "IOS Development",
      href: "#",
    },
    {
      _id: 7,
      title: "Java Development",
      href: "#",
    },
    {
      _id: 8,
      title: "Android Development",
      href: "#",
    },
    {
      _id: 9,
      title: "Frontend",
      href: "#",
    },
    {
      _id: 10,
      title: "Digital Marketing",
      href: "#",
    },
  ],

  support: [
    {
      _id: 1,
      title: "Bog'lanish",
      href: "#",
    },
    {
      _id: 2,
      title: "Telegram Bot",
      href: "#",
    },
    {
      _id: 3,
      title: "Qo'llanma",
      href: "#",
    },
  ],
};
